var exports = {
  "kL": "VideoPlayer.module__container___TkhSSl",
  "Ki": "VideoPlayer.module__video___TkhSSl",
  "ER": "VideoPlayer.module__videoHidden___TkhSSl",
  "mz": "VideoPlayer.module__seekPreviewVideo___TkhSSl",
  "IN": "VideoPlayer.module__posterOverlay___TkhSSl",
  "lW": "VideoPlayer.module__posterImage___TkhSSl",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___TkhSSl",
  "HT": "VideoPlayer.module__playOverlayButton___TkhSSl",
  "$Z": "VideoPlayer.module__controlsOverlay___TkhSSl",
  "hr": "VideoPlayer.module__progressBar___TkhSSl",
  "xu": "VideoPlayer.module__controlsRow___TkhSSl",
  "it": "VideoPlayer.module__controlsLeft___TkhSSl",
  "QE": "VideoPlayer.module__controlsCenter___TkhSSl",
  "BT": "VideoPlayer.module__controlsRight___TkhSSl",
  "sL": "VideoPlayer.module__playPauseIndicator___TkhSSl",
  "HA": "VideoPlayer.module__fillContainer___TkhSSl",
  "Y5": "VideoPlayer.module__fullscreen___TkhSSl",
};

module.exports = exports;
